var arrToObj = (arr) => {
  var obj = {};
  arr.forEach((a) => {
    obj[a[0]] = a[1];
  });
  return obj;
};
let types = {
  SELECT_BOX: "select",
  SELECT_BOX2: "select2",
  SELECT_BOX3: "select3",
  SELECT_BOX4: "select4",
  RADIO_BUTTON: "radio_button",
  INPUT: "input",
  DATE_PICKER: "date_picker",
  CURRENT_TIME: "current_time",
  PASSWORD: "password",
  TEXT_AREA: "text_area",
  CHECKBOX: "checkbox",
  SPACE: "space",
  BUTTON: "button",
};

let arr = [
  {
    id: "seq_id",
    label: "Unique Key",
    type: types.INPUT,
  },
  {
    id: "fk_id",
    label: "fk_id",
    type: types.INPUT,
  },
  {
    id: "tab_id",
    label: "tab_id",
    type: types.INPUT,
  },
  {
    id: "ref_id",
    label: "証書管理番号",
    type: types.INPUT,
    import: {
      enabled: true,
      alias:["証書管理番号\r\n(必須)"]
    },
  },
  {
    id: "req_seq",
    tab_size:10,
    label: "証書管理番号(old)",
    type: types.INPUT,
    import: { enabled: true },
  },
  {
    id: "number_cert",
    tab_size:15,
    label: "証書管理番号",
    type: types.INPUT,
    import: {
      enabled: true
    },
  },
  {
    id: "license_name",
    label: "ライセンス名",
    type: types.INPUT,
    error_if_blank:true,
    import: { enabled: true },
  },
  {
    id: "software_name",
    label: "ソフトウェア名",
    type: types.SELECT_BOX4,
    error_if_blank:true,
    api: "/master_software/list_software_name",
    // It receive a event to be received by BOX4 and execute a filter.
    // It is also received as a parameter at API.
    api_filter_bus_key:"associated_device_manufacture_name_software_name",
    import: { enabled: true },
  },
  {
    id: "product_key",
    label: "プロダクトキー",
    type: types.INPUT,
    import: { enabled: true },
  },

  {
    id: "upgrade",
    label: "アップグレード",
    type: types.SELECT_BOX,
    options: [
      "有",
      "無",
    ],
    default_value:"無",
    import: { 
      enabled: true,
      alias:["アップグレード\r\n(有/無)"]
     },
  },
  {
    id: "unlimited",
    label: "無制限",
    type: types.SELECT_BOX,
    no_blank:true,
    default_value:"ー",
    options: [
      "無制限",
      "ー",
    ],
    import: { 
      enabled: true,
      alias:["無制限\r\n(無制限/-)"]
    },
  },
  {
    id: "license",
    label: "使用するライセンス数",
    type: types.INPUT,
    error_if_blank:true,
    field_type:"number",
    min_value:"0",
    import: { enabled: true },
  },
  {
    id: "number_of_upgrades",
    label: "アップグレード数",
    type: types.INPUT,
    field_type:"number",
    min_value:"0",
    import: { enabled: true },
  },
  {
    id: "effective_number",
    label: "有効数",
    type: types.INPUT,
    import: { enabled: true },
  },
  {
    id: "second",
    label: "セカンド",
    tab_size:10,
    type: types.SELECT_BOX,
    default_value:"無",
    options: [
      "有", 
      "無", 
    ],
    import: { enabled: true },
  },
  {
    id: "maximum_usable_number",
    label: "最大使用可能数",
    tab_size:10,
    type: types.INPUT,
    import: { enabled: true },
  },
  {
    id: "number_of_use",
    label: "使用数",
    type: types.INPUT,
    import: { enabled: true },
  },
  {
    id: "the_number_of_remaining",
    label: "残数",
    type: types.INPUT,
    tab_size:20,
    import: { enabled: true },
  },
  {
    id: "second_number",
    label: "セカンド数",
    type: types.INPUT,
    field_type:"number",
    min_value:"0",
    import: { enabled: true },
  },
  {
    id: "more_details",
    label: "詳細",
    type: types.INPUT,
  },
  {
    id: "button_options",
    history_label_name: "hide",
    label: "ﾁｪｯｸ",
    type: types.INPUT,
  },
];
var ret = {};
var s = 1;
arr.forEach(function (e) {
  if(!RegExp("^[a-z][a-z0-9_]+$").test(e.id)){alert("Invalid field " + e.id);};
  e["tab_label"] = e.tab_label || e.label;
  e["seq_id"] = s++;
  ret[e.id] = e;
});
ret.array = arr;
export const fields = ret;
export const filed_types = types;



// WEBPACK FOOTER //
// ./src/rules/fields_associated_device.js